import MUIButton from "@material-ui/core/Button";
import React, { ButtonHTMLAttributes, FC, ReactNode } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

type SecondaryButtonProps = {
  children: ReactNode;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

const StyledButton = styled(MUIButton)(({ theme }: { theme: Theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  height: 36,
  padding: "0 14px",
  borderRadius: 8,
  border: `1px solid ${theme.palette.brand.gray200}`,
  background: theme.palette.brand.white,
  color: theme.palette.brand.gray700,
  fontSize: 13,
  fontWeight: 500,
  textTransform: "none",
  "& .MuiButton-label": {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  "&:hover": {
    borderColor: theme.palette.brand.gray300,
    color: theme.palette.brand.gray900,
    background: theme.palette.brand.white,
  },
}));

const SecondaryButton: FC<SecondaryButtonProps> = ({ children, onClick, type = "button", disabled }) => (
  <StyledButton disableElevation variant="outlined" type={type} onClick={onClick} disabled={disabled}>
    {children}
  </StyledButton>
);

export default SecondaryButton;
